import { DataButton } from "@sellar-io/components";
import { useBuyerRelationshipFavouriteDelete } from "../../hooks/api/v2/buyerRelationshipFavourite/useBuyerRelationshipFavouriteDelete";
import { Icon } from "../index";

export const RemoveFromFavouritesButton = ({
  buyerRelationshipFavouriteId,
  setAddedToFavourites,
}: {
  buyerRelationshipFavouriteId?: number;
  setAddedToFavourites: (addedToFavourites: boolean) => void;
}) => {
  const removeFromFavouritesMutation = useBuyerRelationshipFavouriteDelete(
    buyerRelationshipFavouriteId || 0,
  );
  const removeFromFavourites = () => {
    if (!buyerRelationshipFavouriteId)
      throw new Error(
        "No relationship favourite found. Can not remove from list",
      );
    return removeFromFavouritesMutation.mutate(undefined, {
      onSuccess: () => setAddedToFavourites(false),
    });
  };
  return (
    <DataButton
      active={true}
      className={"w-fit"}
      onClick={() => removeFromFavourites()}
      border={true}
      loading={removeFromFavouritesMutation.isPending}
    >
      <Icon icon={"HEART"} className={"text-purple-800"} />
    </DataButton>
  );
};
